import { AfterViewInit, Component, ElementRef, Input, OnInit } from '@angular/core';
import { Flags } from '../../../types/flags.type';

@Component({
  selector: 'app-mu-sidebar',
  templateUrl: './mu-sidebar.component.html',
  styleUrls: ['./mu-sidebar.component.sass'],
})
export class MuSidebarComponent<FlagType> implements OnInit, AfterViewInit {
  @Input() customClass: string;
  @Input() contentClass: string;
  @Input() id: string;
  @Input() flagList: Flags<FlagType>;
  @Input() showFlag: FlagType;
  @Input() size = 0;
  @Input() skin: boolean;

  constructor(private elementRef: ElementRef) {
    /** */
  }

  ngOnInit(): void {
    /** */
  }

  ngAfterViewInit(): void {
    const element: HTMLElement = this.elementRef.nativeElement.firstElementChild;
    element.style.opacity = '';
  }

  get baseClass() {
    let baseClass = 'mu-sidebar';
    baseClass += ' ' + this.customClass;
    baseClass += ' ' + (this.flagList.get(this.showFlag) ? 'mu-sidebar-active' : '');
    return baseClass;
  }

  /**
   * close sidebar
   */
  closeSidebar(): void {
    this.flagList.disable(this.showFlag);
  }
}
